// @flow

import 'isomorphic-fetch';
import type { ApiSaveAnswersRequest } from './dtos/api-save-answers-request';
import ApiFeedbackError from './ApiFeedbackError';
import { API_TIMEOUT } from '../common/constants';

const ENDPOINTS = {
  SAVE_FEEDBACK: '/results',
};

// $FlowFixMe
const REQUEST_OPTIONS: $Shape<RequestOptions> = {
  mode: 'cors',
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
};

export default class ApiFeedback {
  urlBase: string;

  constructor(urlBase: string) {
    this.urlBase = urlBase;
  }

  async get(url: string): Promise<any> {
    try {
      const response = await fetch(url, { method: 'GET', ...REQUEST_OPTIONS });
      return response.json();
    } catch (error) {
      throw new ApiFeedbackError(error.code, error.message);
    }
  }

  async post(url: string, body?: Object): Promise<void> {
    try {
      // Api response and error handling are ignored
      // Errors are silently ignored
      await fetch(url, { body: JSON.stringify(body), method: 'POST', ...REQUEST_OPTIONS });
    } catch (error) {
      throw new ApiFeedbackError('', error.message);
    }
  }

  async saveAnswers(apiSaveAnswersRequest: ApiSaveAnswersRequest): Promise<void> {
    const url = `${this.urlBase}${ENDPOINTS.SAVE_FEEDBACK}`;
    await this.post(url, apiSaveAnswersRequest);
  }
}



// WEBPACK FOOTER //
// ./app/sdk/feedback/ApiFeedback.js